// src/utils/auth.js

export const getCurrentUser = () => {
  const user = localStorage.getItem("user");

  return user ? JSON.parse(user) : null;
};

export const getAccessToken = () => {
  return localStorage.getItem("access");
};